import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(private http: HttpClient) { }

  getUserAlerts(){
    return this.http.get(environment.url + `user/alerts?type=feature`);

  }

  postponeAlert(alert_user){
    return this.http.post(environment.url + `user/alerts/${alert_user}/postponed`,{});
  }
  markAsReadAlert(alert_user){
    return this.http.post(environment.url + `user/alerts/${alert_user}/read`,{});
  }
}
